import * as React from 'react'

import { BankToAutoLinkingProps } from '@ally/transmitigator'
import { Space } from '@ally/metronome-ui'
import { LoginHeading } from '@ally/ally-login'

import { useTransmit } from '../../TransmitContext'
import { CIAMErrorBanner, StyledTextBody } from '../Shared'
import { AutoLoginForm } from './AutoLoginForm'
import { useHostServices } from '../../HostServices'
import {
  AccountLinkingScreen,
  AccountLinkingStepper,
  AccountLinkingContainer,
  AccountLinkingContentWrapper,
  AccountLinkingStepperWrapper,
} from '.'

const BankToAutoLinkingContent: React.FC<BankToAutoLinkingProps> = ({
  onComplete,
  status,
  userRelationships,
  authenticatedUsername,
  error,
  softLinkedUsername,
}) => {
  const { analytics } = useHostServices()

  React.useEffect(() => {
    analytics.trackPageView({
      eventType: 'pageview',
      pageName: 'AOS:Login:Link Auto Account',
    })
  }, [])

  return (
    <AccountLinkingContainer>
      <AccountLinkingContentWrapper>
        <LoginHeading title="Enter your Auto password." />

        <Space mb="lg">
          <StyledTextBody size="sm" tag="p">
            This is the last time you&apos;ll need your Auto username and
            password. Once you enter your password, we&apos;ll connect your
            accounts.
          </StyledTextBody>
        </Space>

        <CIAMErrorBanner error={error} />

        <AutoLoginForm
          onComplete={onComplete}
          softLinkedUsername={softLinkedUsername}
          status={status}
        />
      </AccountLinkingContentWrapper>
      <AccountLinkingStepperWrapper>
        <AccountLinkingStepper
          screen={AccountLinkingScreen.AutoToBank}
          userRelationships={userRelationships}
        />
      </AccountLinkingStepperWrapper>
    </AccountLinkingContainer>
  )
}

export const BankToAutoLinking: React.FC = () => {
  const { activeScreen } = useTransmit()

  if (activeScreen.type !== 'BankToAutoLinking') {
    return null
  }

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <BankToAutoLinkingContent {...activeScreen.payload} />
}
